import { combineReducers } from 'redux';

import { ffrViewReducer } from './ffrviewreducer';

export const rootReducer = combineReducers({
  viewer: ffrViewReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
